<template>
	<div class="container">

		<div class="form-register-message" v-if="state == 'loading'">
			<div class="container">
				<div class="body alert-light">
					<strong>درحال ثبت درخواست شما هستیم، لطفا منتظر بمانید ...</strong>
				</div>
			</div>
		</div>

		<div class="form-register-message" v-if="state == 'error'">
			<div class="container">
				<div class="body alert-warning">
					<strong>ثبت درخواست با خطا مواجه شد.</strong>
					<p>لطفا با تیم پشتیبانی آنی رسان تماس حاصل فرمایید</p>
				</div>
			</div>
		</div>

		<div class="form-register-message" v-if="state == 'success'">
			<div class="container">
				<div class="body alert-success">
					<strong>ثبت درخواست با موفقیت انجام شد.</strong>
					<p>ظرف 72 ساعت آینده با استفاده از  کد رهگیری زیر و مراجعه به لینک "اخذ نمایندگی" و سپس "پیگیری ثبت نمایندگی" می توانید نتیجه درخواست خود را مشاهده نمایید.</p>

					<div class="d-block mt-5"> کد رهگیری شما برابر است با : <strong>{{registerRequestID}}</strong></div>
				</div>
			</div>
		</div>



		<section class="form-register p-number" v-if="state == 'getData'">
			<component :is="activeForm"
					   :contract="contract"
					   :init="initTabContent"
					   v-on:change="(el) => changeFormValue(el)" />
			<div class="buttons p-0 pt-md-5">
				<button class="btn form-btn" @click="prev()" v-if="activeIndex>0">
					<i class="bi bi-arrow-right me-2"></i>
					<span>قبلی</span>
				</button>
				<button class="btn form-btn" @click="next()" v-if="activeIndex<forms.length-1">
					<span>بعدی</span>
					<i class="bi bi-arrow-left ms-2"></i>
				</button>
				<div v-if="activeIndex==forms.length-1" @click="sendRequest" class="btn form-btn pt-3">
					<span>ثبت نهایی اطلاعات</span>
				</div>
			</div>
			<div style="text-align:center; margin-top:40px;">
				<span v-for="(item,index) in forms"
					  v-bind:class="{'active': index == activeIndex}"
					  :key="item.name"
					  class="step">{{index+1}}</span>
			</div>
			<div class="pt-5" v-if="activeIndex==forms.length-1">
				<p>سپاس از شما که وقت گران قدر خودرا در اختیار ما گذاشتید همکاری با شما باعث سرافرازی و افتخار ما می باشد.با تشکر از شما" روابط عمومی شرکت پیام بارآسمان آسیا(آنی رسان)"</p>
			</div>
		</section>
	</div>
</template>
<script>
	import "@/assets/css/register.css";
	import Compressor from 'compressorjs';
	import { defineAsyncComponent } from "vue";
	export default {
		components: {
			"register-personalInfo": defineAsyncComponent(() =>
				import("./register-personalInfo.vue")
			),
			"register-otherInfo": defineAsyncComponent(() =>
				import("./register-otherInfo")
			),
			"register-locationInfo": defineAsyncComponent(() =>
				import("./register-locationInfo")
			),
			"register-educationInfo": defineAsyncComponent(() =>
				import("./register-educationInfo")
			),
			"register-gradeInfo": defineAsyncComponent(() =>
				import("./register-gradeInfo")
			),
			"register-records": defineAsyncComponent(() =>
				import("./register-records")
			),
			"register-jobTenureInfo": defineAsyncComponent(() =>
				import("./register-jobTenureInfo")
			),
			"register-languageInfo": defineAsyncComponent(() =>
				import("./register-languageInfo")
			),
			"register-supplementaryInfo": defineAsyncComponent(() =>
				import("./register-supplementaryInfo")
			),
			"register-familiar": defineAsyncComponent(() =>
				import("./register-familiar")
			),
			"register-jobInfo": defineAsyncComponent(() =>
				import("./register-jobInfo")
			),
			"register-attachment": defineAsyncComponent(() =>
				import("./register-attachment")
			),
			"register-preview": defineAsyncComponent(() =>
				import("./register-preview")
			),
		},

		data()
		{
			return {
				forms: [
					{ name: "register-personalInfo" },
					{ name: "register-otherInfo" },
					{ name: "register-locationInfo" },
					{ name: "register-educationInfo" },
					{ name: "register-gradeInfo" },
					{ name: "register-records" },
					{ name: "register-jobTenureInfo" },
					{ name: "register-languageInfo" },
					{ name: "register-supplementaryInfo" },
					{ name: "register-familiar" },
					{ name: "register-jobInfo" },
					{ name: "register-attachment" },
					{ name: "register-preview" },
				],
				state: 'getData',
				registerRequestID :0,
				activeIndex: 0,
				contract: {
					personalInfo: {
						firstName: null,
						lastName: null,
						id: null,
						NationalCode: null,
						place: null,
						local: null,
						birthday: null,
						fName: null,
						fJob: null,
					},

					otherInfo: {
						health: null,
						licence: null,
						soldier: null,
						work: null,
						marriage: null,
						partner: null,
						employed: null,
						jobSide: null,
						company: null,
					},

					locationInfo: {
						home: null,
						price: null,
						member: null,
						address: null,
						phoneNumber: null,
						fAddress: null,
						fNumber: null,
						person: null,
						pNumber: null,
					},

					educationInfo: [],
					gradeInfo: [],
					jobTenureInfo: [],
					languageInfo: [],
					SupplementaryInfo: [],
					familiarInfo: [],
					jobInfo: {
						currentJob: null,
						recruitment: null,
						introduce: null,
						favorite: null,
						hours: null,
						salary: null,
						start: null,
						criminal: null,
						addictive: null,
					},
					records: {
						disease: null,
						czech: null,
						insurance: null,
						insureNumber: null,
						idInsurance: null,
						codeInsurance: null,
						startOfPension: null,
						money: null,
						branchInsurance: null,
						endOfPension: null,
					},
					attachment: {

					}
				},
			};
		},

		computed: {
			activeForm()
			{
				return this.forms[this.activeIndex].name;
			},
		},

		methods: {
			moveUp()
			{
				window.scrollTo(0, 0);
			},

			async next()
			{
				const isValid = await this.validationTab();

				if (isValid && this.activeIndex < this.forms.length)
				{
					this.moveUp();
					this.activeIndex += 1;
				}
			},

			prev()
			{
				if (this.activeIndex > 0)
				{
					this.moveUp();
					this.activeIndex -= 1;
				}
			},


			toDataURL(file)
			{
				return new Promise((resolve, reject) =>
				{
					new Compressor(file, {
						quality: 0.6,
						maxWidth: 900,

						// The compression process is asynchronous,
						// which means you have to access the `result` in the `success` hook function.
						success(result)
						{
							const reader = new FileReader();
							reader.readAsDataURL(result);
							reader.onload = () => resolve(reader.result);
							reader.onerror = error => reject(error);
						},
						error(err)
						{
							console.log(err.message);
						},
					});
				});
			},


			sendRequest()
			{

				this.state = 'loading'

				this.$server({
					method: "post",
					url: "/api/General/SaveRegisterRequest",
					data: {
						Contract: JSON.stringify(this.contract)
					}
				})
					.then((response) =>
					{

						if (response.data.RegisterRequestID > 0)
						{
							this.state = 'success'
							this.registerRequestID = response.data.RegisterRequestID;
							return;
						};

						this.state = 'error'
					})
					.catch((error) =>
					{
						this.state = 'error'
					});
			},


			initTabContent()
			{
				var cntr = this.contract;
				if (cntr)
				{
					var tabName = document
						.querySelector(".tab")
						.getAttribute("data-name");

					if (cntr[tabName])
					{
						for (const key of Object.keys(cntr[tabName]))
						{
							var inputs = document.querySelectorAll(
								`textarea[name='${key}'],input[name='${key}']`
							);

							for (const input of inputs)
							{
								switch (input.getAttribute("type"))
								{
									case "radio":
										if (input.value === cntr[tabName][key])
										{
											input.checked = true;
										}
										break;

									default:
										input.value = cntr[tabName][key];
										break;
								}
							}
						}
					}
				}
			},

			isValid(pattern, value)
			{
				switch (pattern)
				{
					case "checkEmpty":
						if (value == undefined || value == null || value == "")
						{
							return false;
						}
						break;

					default:
						break;
				}
				return true;
			},

			async validationTab()
			{
				var tab = document.querySelector(".tab");
				if (tab.getAttribute("data-type") == "form")
				{
					var validateResult = await this.changeFormValue();
					return validateResult;

				} else
				{
					return this.changeTableValue();
				}
			},

			changeTableValue(el)
			{
				var errorLength = 0;
				var tab = document.querySelector(".tab");
				var tabPropertyName = tab.getAttribute("data-name");
				var rows = tab.querySelectorAll("table tr");
				this.contract[tabPropertyName] = [];
				var index = 0;
				for (const row of rows)
				{
					if (index == 0)
					{
						index = 1;
						continue;
					}
					var inputs = row.querySelectorAll("textarea,input");
					var data = {};

					for (const input of inputs)
					{
						if (el && el.name != input.name)
						{
							continue;
						}

						var value = "";
						switch (input.getAttribute("type"))
						{
							case "radio":
								if (input.checked)
								{
									value = input.value;
								}
								break;

							default:
								value = input.value;
								break;
						}

						var pettern = input.getAttribute("data-pattern");
						var name = input.getAttribute("data-name");
						var label = document.querySelector(`label[id=${name}]`);

						if (name != "")
						{
							if (label && pettern)
							{
								if (!this.isValid(pettern, value))
								{
									label.innerHTML = "این فیلد اجباری است";
									errorLength += 1;
								} else label.innerHTML = "";
							}
							var propertyName = name;

							if (value != "")
							{
								data[propertyName] = value;
							}
						}
					}
					this.contract[tabPropertyName].push(data);
				}

				return errorLength == 0;
			},

			async changeFormValue(el)
			{
				var errorLength = 0;
				var tab = document.querySelector(".tab");
				var inputs = tab.querySelectorAll("input");

				for (const input of inputs)
				{
					if (el && el.name != input.name)
					{
						continue;
					}

					var value = "";
					switch (input.getAttribute("type"))
					{
						case "radio":
							if (input.checked)
							{
								value = input.value;
							}
							break;


						case "file":
							if (input.files[0])
							{
								value = await this.toDataURL(input.files[0]);
							}
							break;

						default:
							value = input.value;
							break;
					}
					var pettern = input.getAttribute("data-pattern");
					var label = document.querySelector(`label[id=${input.name}]`);

					if (input.name != "")
					{
						if (label && pettern)
						{
							if (!this.isValid(pettern, value))
							{
								label.innerHTML = "این فیلد اجباری است";
								errorLength += 1;
							} else label.innerHTML = "";
						}

						var tabPropertyName = tab.getAttribute("data-name");
						var propertyName = input.name;

						if (value != "")
						{
							this.contract[tabPropertyName][propertyName] = value;
						}
					}
				}

				return errorLength == 0;
			},
		},
	};
</script>
<style scoped>
	.form-register {
		width: 100%;
		margin: 100px 0;
		padding: 50px;
		border: 1px solid #ebc75d;
		border-radius: 10px;
		position: relative;
	}

		/* //////////////////////////////////////////////////// */
		.form-register .buttons {
			width: 100%;
			background-color: #fff;
			text-align: center;
		}

			.form-register .buttons button:active {
				outline: unset;
				border: none;
			}

			.form-register .buttons button:focus {
				outline: unset;
				border: none;
			}

			.form-register .buttons .form-btn {
				width: 150px;
				height: 50px;
				text-align: center;
				margin: 10px;
				border: 1px solid #ebc75d;
			}

				.form-register .buttons .form-btn i {
					font-size: 20px;
					color: #ebc75d;
					top: 5px;
					display: inline-block;
					position: relative;
				}

	@media screen and (max-width: 768px) {
		.form-register {
			padding: 80px 10px;
			margin: 0;
         border: unset;
		}
	}

	.form-register-message {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(248,248,248,1);
		text-align: center;
		z-index: 100;
	}

		.form-register-message .body {
			position: relative;
			margin-top: 150px;
			font-size: 16px;
			padding: 50px 10px;
			border-radius: 20px;
		}
</style>
